import { render, staticRenderFns } from "./groupDiv.vue?vue&type=template&id=53daf68c&"
import script from "./groupDiv.vue?vue&type=script&lang=js&"
export * from "./groupDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports